<template>
  <div>
    <title-block id="bm0" v-if="titles[0].num">
      <template slot="title">{{titles[0].label}}</template>
      <div class="mt-10">
        <el-tag v-for="item in platform" :key="item" type="info" effect="plain" class="mr-5 mb-5">
          {{ item }}
        </el-tag>
        <div class="center">
          <pagination :pageNum="personnel.pageNum" :total="personnel.total" @currentChange="val => handleCurrentChange(val, 2)" />
        </div>
      </div>
    </title-block>

    <title-block id="bm1" v-if="titles[1].num">
      <template slot="title">{{titles[1].label}}</template>
      <div class="mt-10">
        <el-table :data="record.tableData" border :header-cell-style="{background: '#fafafa',color: '#333'}">
          <el-table-column label="人员姓名" prop="changeTime" align="center">
            <template slot-scope="scope">{{ scope.row.changeTime||'--' }}</template>
          </el-table-column>
          <el-table-column label="职位" prop="changeItem" align="center">
            <template slot-scope="scope">{{ scope.row.changeItem||'--' }}</template>
          </el-table-column>
          <el-table-column label="简介" prop="changeItem" align="center">
            <template slot-scope="scope">{{ scope.row.changeItem||'--' }}</template>
          </el-table-column>
        </el-table>
        <div class="center">
          <pagination :total="record.total" @currentChange="val => handleCurrentChange(val, 3)" />
        </div>
      </div>
    </title-block>

    <title-block id="bm2" v-if="titles[2].num">
      <template slot="title">{{titles[2].label}}</template>
      <div class="tables mt-10">
        <el-table :data="personnel.tableData" border :header-cell-style="{background: '#fafafa',color: '#333'}">
          <el-table-column label="产品名称" prop="name" align="center">
            <template slot-scope="scope">{{ scope.row.name||'--' }}</template>
          </el-table-column>
          <el-table-column label="产品标签" prop="typeJoin" align="center">
            <template slot-scope="scope">
              <div v-if="scope.row.typeJoin&&scope.row.typeJoin.length>0">{{ scope.row.typeJoin.join('，') }}</div>
              <div v-else>--</div>
            </template>
          </el-table-column>
          <el-table-column label="产品官网" prop="name" align="center">
            <template slot-scope="scope">{{ scope.row.name||'--' }}</template>
          </el-table-column>
          <el-table-column label="产品简介" prop="name" align="center">
            <template slot-scope="scope">{{ scope.row.name||'--' }}</template>
          </el-table-column>
          <el-table-column label="所属公司" prop="name" align="center">
            <template slot-scope="scope">{{ scope.row.name||'--' }}</template>
          </el-table-column>
        </el-table>
        <div class="center">
          <pagination :pageNum="personnel.pageNum" :total="personnel.total" @currentChange="val => handleCurrentChange(val, 2)" />
        </div>
      </div>
    </title-block>
  </div>
</template>

<script>
import titleBlock from './titleBarBlock'
import Pagination from '@/components/paginationSimple'
import { areaCode } from '@/base/areaCode.js'
import { holder, keyMan, changeInfo } from '../api/index.js'
export default {
  name: '',
  components: {
    titleBlock,
    Pagination
  },
  props: {
    tabsInfo: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    tabsInfo: {
      deep: true,
      immediate: true,
      handler(val) {
        this.titles.forEach(e => {
          val.forEach(ele => {
            if (ele.name === e.label) {
              e.moduleId = ele.moduleId
              e.num = ele.total
            }
          })
        })
        this.$emit('setTitle', this.titles)
      }
    }
  },
  data() {
    return {
      titles: [
        { type: '', label: '投放平台', num: 0 },
        { type: '', label: '网络推广', num: 0 },
        { type: '', label: '媒体广告', num: 0 },
      ],
      platform: ['百度',

        '百度关键词字竞价广告',

        '闪电盒子(APP)',

        '投放平台',

        '车轮查违章',

        '她社区',

        '安卓动态壁纸',

        '惠头条',

        '豹来电',

        '车来了(APP)',

        '淘新闻',

        '快看影视'],
      name: this.$route.query.name,
      areaCode: areaCode,
      shareholder: {
        tableData: [],
        pageNum: 1,
        total: 0
      },
      personnel: {
        tableData: [],
        pageNum: 1,
        total: 0
      },
      record: {
        tableData: [],
        pageNum: 1,
        total: 0
      }

    }
  },
  mounted() {
    this.$emit('setTitle', this.titles)
    // this.holder()
    // this.keyMan()
    // this.changeInfo()
  },
  computed: {
  },
  methods: {
    holder() {
      var data = {
        name: this.name,
        pageNum: this.shareholder.pageNum
      }
      holder(data).then(res => {
        if (res.data) {
          this.shareholder.tableData = res.data.items
          this.shareholder.total = res.data.total
        } else {
          this.shareholder.tableData = []
          this.shareholder.total = 0
        }
      })
    },
    keyMan() {
      var data = {
        name: this.name,
        pageNum: this.personnel.pageNum
      }
      keyMan(data).then(res => {
        if (res.data) {
          this.personnel.tableData = res.data.items
          this.personnel.total = res.data.total
        } else {
          this.personnel.tableData = []
          this.personnel.total = 0
        }
      })
    },
    changeInfo() {
      var data = {
        name: this.name,
        pageNum: this.record.pageNum
      }
      changeInfo(data).then(res => {
        if (res.data) {
          this.record.tableData = res.data.items
          this.record.total = res.data.total
        } else {
          this.record.tableData = []
          this.record.total = 0
        }
        this.$nextTick(() => {
          var html = document.getElementsByClassName('div-html')
          for (var i = 0; i < html.length; i++) {
            html[i].innerHTML = html[i].innerHTML.replace(/(<\/?a.*?>)/g, '')
          }
        })
      })
    },
    getBase(val) {
      var base = '--'
      if (val) {
        for (var i = 0; i < this.areaCode.length; i++) {
          if (val === this.areaCode[i].base) {
            base = this.areaCode[i].name
            break
          }
        }
      }
      return base
    },
    handleCurrentChange(val, sign) {
      if (sign === 1) {
        this.shareholder.pageNum = val
        this.holder()
      } else if (sign === 2) {
        this.personnel.pageNum = val
        this.keyMan()
      } else if (sign === 3) {
        this.record.pageNum = val
        this.changeInfo()
      }
    }
  }
}
</script>

<style scoped lang="scss">
/deep/ .el-table th > .cell {
  font-size: 12px;
  font-weight: 400;
}
/deep/ .el-table th {
  padding: 10px 0;
  line-height: 16px;
}
</style>
